import { useCallback } from "react";
import { useAtom } from "jotai";
import type { AuthCredentials } from "../../interface/auth_types";
import { remoteClientAuthenticatedCredentialsAtom } from "../atom/remoteClientAuthenticatedCredentialsAtom";

export default function useAuthenticatedCredentials() {
  const [authenticatedCredentials, setAuthenticatedCredentials] = useAtom(
    remoteClientAuthenticatedCredentialsAtom,
  );

  const clearAuthenticatedCredentials = useCallback(() => {
    setAuthenticatedCredentials(null);
  }, [setAuthenticatedCredentials]);

  const updateAuthenticatedCredentials = useCallback(
    (credentials: AuthCredentials | null) => {
      setAuthenticatedCredentials(credentials);
    },
    [setAuthenticatedCredentials],
  );

  return {
    authenticatedCredentials,
    setAuthenticatedCredentials: updateAuthenticatedCredentials,
    clearAuthenticatedCredentials,
  };
}
